import React from "react";
import "./CustomDrawer.scss";

function CustomDrawer({ Component, visible }) {
  return (
    <>
      <div className={`Custom-Drawer ${visible ? "open" : "closed"}`}></div>
      <div className={`loader-container ${visible ? "open" : "closed"}`}>
        <Component />
      </div>
    </>
  );
}

export default CustomDrawer;